import Select from "react-select";
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg";
import { FC } from "react";
import { County } from "services";
import { SelectedCountyStation } from "../../../types/AlarmModels";
import { Station } from "../../../types/AlarmsForm";
import { IconButton } from "modules/common/components/Alarms/Form/components/IconButton";

// TODO: use Dropdown instead of Select
interface Props {
    counties: County[];
    stations: Station[];
    selectedCountyStation: SelectedCountyStation;
    selectedCountyStations: SelectedCountyStation[];
    onCountyChange: (currentCounty?: County, newCounty?: County, currentStation?: Station) => void;
    onStationChange: (currentStation?: Station, newStation?: Station) => void;
    removeCountyStation: (county?: County, station?: Station) => void;
}

const CountyStation: FC<Props> = ({
    selectedCountyStation,
    selectedCountyStations,
    counties,
    stations,
    onCountyChange,
    onStationChange,
    removeCountyStation,
}) => {
    const currentCounty = counties.find(c => c.id === selectedCountyStation.countyId);
    const countyStations = stations.filter(s => s.zupanija?.id === selectedCountyStation.countyId);
    const currentStation = countyStations.find(s => s.id === selectedCountyStation.stationId);

    const filteredStations = countyStations.filter(
        s =>
            s.id !== currentStation?.id &&
            !selectedCountyStations.some(
                ss => ss.stationId === s.id && ss.countyId === currentCounty?.id
            )
    );

    return (
        <div className="alarms-form-country-station-inputs alarms-form-container">
            <div>
                <label>Županija</label>
                <Select
                    value={currentCounty}
                    placeholder="Odaberite županiju"
                    options={counties}
                    getOptionLabel={c => c.name}
                    getOptionValue={c => String(c.id)}
                    onChange={newCounty =>
                        onCountyChange(currentCounty, newCounty ?? undefined, currentStation)
                    }
                />
            </div>
            <div>
                <label>Stanica</label>
                <Select
                    value={currentStation}
                    placeholder="Odaberite stanicu"
                    options={filteredStations}
                    getOptionLabel={s => s.name}
                    getOptionValue={s => String(s.id)}
                    onChange={newStation =>
                        onStationChange(currentStation, newStation ?? undefined)
                    }
                />
            </div>
            <IconButton
                onClick={() => removeCountyStation(currentCounty, currentStation)}
                type="button"
            >
                <DeleteIcon />
            </IconButton>
        </div>
    );
};

export default CountyStation;
